import styled from "styled-components";
import { BREAKPOINTS, COLORS } from "@laerdal/life-react-components";

export const ContentColumn = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 64px;
`;

export const ArticleHtmlContainer = styled.div`
  
  word-wrap: break-word;
  word-break: break-word;
  overflow-wrap: break-word;
  img {
    max-width: 100%;
    height: auto !important;
  }

  table {
    -webkit-overflow-scrolling: touch;

    display: block;
    overflow-x: auto;
    min-width: 100%;
  }

  td, th {
    white-space: nowrap;
    padding: 4px 8px;
  }

  h1 {
    font-family: Lato;
    font-size: 22px;
    font-weight: 700;
    line-height: 120%;
    ${BREAKPOINTS.LARGE}{
      font-size: 26px;
    }
  }

  h2 {
    font-family: Lato;
    font-size: 20px;
    font-weight: 700;
    line-height: 120%;
    ${BREAKPOINTS.LARGE}{
      font-size: 24px;
    }
  }

  h3, h4, h5, h6 {
    font-family: Lato;
    font-size: 18px;
    font-weight: 700;
    line-height: 120%;
    ${BREAKPOINTS.LARGE}{
      font-size: 22px;
    }
  }

  p, span, label, li, td, th, dd, dt, blockquote, figcaption, a {
    font-family: Lato;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
    ${BREAKPOINTS.LARGE}{
      font-size: 20px;
    }
  }

  hr {
    border: none;
    border-top: 1px solid #d2d2d7;
    margin: 2em 0;
  }
`;

export const ArticleFilesContainer = styled.div`
  padding: 16px;
  border: 1px solid ${COLORS.neutral_100};
  border-radius: 4px;
`;

export const FilesTitle = styled.h3`
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  margin-top: 24px;
  color: ${COLORS.black};
`;

export const FileItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  
  &:last-child {
    margin-bottom: 0;
  }
`;

export const FileIcon = styled.div`
  margin-right: 8px;
  color: ${COLORS.neutral_600};
`;

export const FileLink = styled.a`
  color: ${COLORS.accent1_500};
  text-decoration: none;
  font-weight: 500;
  
  &:hover {
    text-decoration: underline;
  }
`;

export const FileSize = styled.span`
  color: ${COLORS.neutral_500};
  font-size: 14px;
  margin-left: 8px;
`;

export const LoadingIndicatorContainer = styled.div`
  margin: 0 auto;
`;

export const ArticlePageContainer = styled.div`
  margin: 0 0 50px 0;
`;

export const BreadcrumbContainer = styled.div`
  padding: 12px 0;
  margin-bottom: 16px;
  ${BREAKPOINTS.LARGE}{
    margin-bottom: 32px;
  }
`;

export const ArticleTitle = styled.h3`
  color: var(--life-color-text-default);
  font-feature-settings: 'liga' off;
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  margin-bottom: 16px;
  ${BREAKPOINTS.LARGE}{
    font-size: 30px;
  }
`;

export const CrumbLink = styled.a`
  &:link, &:visited, &:hover, &:active {
    color: ${COLORS.primary_600};
    text-decoration: none; 
  }
  color: ${COLORS.primary_600};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const CrumbText = styled.span`
  color: ${COLORS.neutral_500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const BreadcrumbDivider = styled.span`
  padding: 0 10px;
  color: ${COLORS.neutral_500};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 25px; 
`;

export const RelatedArticlesContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 48px;
  align-items: flex-start;
  row-gap: 16px;
  align-self: stretch;
  margin: 40px 0 0 0;
`;

export const ArticleMeta = styled.div`
  margin-bottom: 32px;
  border-top: 1px solid ${COLORS.neutral_200};
  display: flex;
  align-items: center;
  gap: 8px;

  padding: 12px 0;
  color: var(--life-color-text-subtle);
  font-feature-settings: 'liga' off;
  /* Components/Regular/XS */
  font-family: Lato;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px; /* 114.286% */

  svg {
    width: 4px;
    height: 4px;
  }
`;

export const RelatedArticlesTitle = styled.div`
  font-family: Lato;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: 120%;
  ${BREAKPOINTS.LARGE}{
    font-size: 25px;
  }
`;

export const RelatedArticlesList = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 8px;
  border: 1px solid ${COLORS.neutral_200};
  ${BREAKPOINTS.LARGE}{
    padding: 32px;
  }
`;

export const RelatedArticleLink = styled.a`
  color: var(--life-color-text-link);
  font-feature-settings: 'liga' off;
  font-family: Lato;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  text-decoration: none;
  cursor: pointer;
  ${BREAKPOINTS.LARGE}{
    font-size: 20px;
  }
  &:hover {
    text-decoration: underline;
  }
`;

export const AttachmentContainer = styled.div`
  box-sizing: border-box;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  background: ${COLORS.white};
  overflow-y: auto;
  height: 500px;

  .react-pdf__Document {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .react-pdf__Page {
    margin-bottom: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  .react-pdf__Page__canvas {
    max-width: 100%;
    height: auto !important;
  }
`;

export const ImagePreview = styled.img`
  max-width: 100%;
  height: auto;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;
